import { render } from "./AppCommunicationEvent.vue?vue&type=template&id=4b05f3a8"
import script from "./AppCommunicationEvent.vue?vue&type=script&lang=js"
export * from "./AppCommunicationEvent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\anda\\Documents\\onlinefundraising\\of_spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__